import React, { FC } from "react";

import { Dot, DotContainer, DotContainerInner } from "./styles";

interface IProps {
  className?: string;
}

const DotLoader: FC<IProps> = ({ className }) => (
  <DotContainer className={className}>
    <DotContainerInner>
      <Dot></Dot>
    </DotContainerInner>
  </DotContainer>
);

export default DotLoader;
